import { render, staticRenderFns } from "./ExportacaoFolha.vue?vue&type=template&id=01e76571"
import script from "./ExportacaoFolha.vue?vue&type=script&lang=js"
export * from "./ExportacaoFolha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports